import { ReactiveController, ReactiveControllerHost } from 'lit';

export class HeartAnimationController implements ReactiveController {
  private _active = false;
  private hasJustBeenClicked = false;
  private resetTimeout: number | undefined;
  private readonly isTouchDevice: boolean;
  private readonly host: ReactiveControllerHost & HTMLElement;

  get active() {
    return this._active;
  }

  constructor(host: ReactiveControllerHost & HTMLElement) {
    this.host = host;
    host.addController(this);
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  hostDisconnected() {
    window.clearTimeout(this.resetTimeout);
    if (!this.isTouchDevice) {
      this.host.removeEventListener('mouseleave', this.resetScheduled);
    }
  }

  trigger() {
    if (this.isTouchDevice) {
      this.resetScheduled();
    } else {
      this.host.addEventListener('mouseleave', this.resetScheduled);
    }
    this._active = true;
    this.hasJustBeenClicked = true;
    this.host.requestUpdate();
  }

  resetImmediate() {
    window.clearTimeout(this.resetTimeout);
    if (!this.isTouchDevice) {
      this.host.removeEventListener('mouseleave', this.resetScheduled);
    }
    this._active = false;
    this.host.requestUpdate();
  }

  shouldBlockUpdate(): boolean {
    if (this._active) {
      if (!this.hasJustBeenClicked) return true;
      this.hasJustBeenClicked = false;
    }
    return false;
  }

  private resetScheduled = () => {
    if (!this.isTouchDevice) {
      this.host.removeEventListener('mouseleave', this.resetScheduled);
    }
    this.resetTimeout = window.setTimeout(() => {
      this._active = false;
      this.host.requestUpdate();
    }, 700);
  };
}
